// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ButtonGroup-module__font-s-10___W82S5 {
  font-size: 10px !important;
}

.ButtonGroup-module__font-s-12___iC0xm {
  font-size: 12px !important;
}

.ButtonGroup-module__font-s-13___nod1S {
  font-size: 13px !important;
}

.ButtonGroup-module__font-s-14___ii1W8 {
  font-size: 14px !important;
}

.ButtonGroup-module__font-s-15___yseB5 {
  font-size: 15px !important;
}

.ButtonGroup-module__font-s-16___MKRwX {
  font-size: 16px !important;
}

.ButtonGroup-module__font-s-18___AYk95 {
  font-size: 18px !important;
}

.ButtonGroup-module__font-s-20___m1jI6 {
  font-size: 20px !important;
}

.ButtonGroup-module__font-s-22___UzsFN {
  font-size: 22px !important;
}

.ButtonGroup-module__font-s-28___kwNpd {
  font-size: 28px !important;
}

.ButtonGroup-module__font-w-400___JGhz_ {
  font-weight: 400 !important;
}

.ButtonGroup-module__font-w-500___gAfyQ {
  font-weight: 500 !important;
}

.ButtonGroup-module__font-w-600___z6Cit {
  font-weight: 600 !important;
}

.ButtonGroup-module__font-w-700___UHNnz {
  font-weight: 700 !important;
}

.ButtonGroup-module__p-5___DXbGS {
  padding: 5px !important;
}

.ButtonGroup-module__p-12____ZrJR {
  padding: 12px !important;
}

.ButtonGroup-module__p-16___MtpqW {
  padding: 16px !important;
}

.ButtonGroup-module__p-30___B18EE {
  padding: 30px !important;
}

.ButtonGroup-module__p-b-0___WdZ_n {
  padding-bottom: 0 !important;
}

.ButtonGroup-module__p-b-5___EFsTx {
  padding-bottom: 5px !important;
}

.ButtonGroup-module__p-b-10___Cz0Rt {
  padding-bottom: 10px !important;
}

.ButtonGroup-module__p-b-12___RlgXw {
  padding-bottom: 12px !important;
}

.ButtonGroup-module__p-b-16___S3Yqy {
  padding-bottom: 16px !important;
}

.ButtonGroup-module__p-b-18___H2qE_ {
  padding-bottom: 18px !important;
}

.ButtonGroup-module__p-b-20___KgRrD {
  padding-bottom: 20px !important;
}

.ButtonGroup-module__p-b-25___PI0Zv {
  padding-bottom: 25px !important;
}

.ButtonGroup-module__p-b-30___ib6EV {
  padding-bottom: 30px !important;
}

.ButtonGroup-module__p-b-50___yE2YN {
  padding-bottom: 50px !important;
}

.ButtonGroup-module__p-t-0___XBthT {
  padding-top: 0 !important;
}

.ButtonGroup-module__p-t-12___wrPfy {
  padding-top: 12px !important;
}

.ButtonGroup-module__p-t-16___EMQmg {
  padding-top: 16px !important;
}

.ButtonGroup-module__p-t-18___eufcU {
  padding-top: 18px !important;
}

.ButtonGroup-module__p-t-20___TUKcU {
  padding-top: 20px !important;
}

.ButtonGroup-module__p-t-30___p55QW {
  padding-top: 30px !important;
}

.ButtonGroup-module__p-t-40___ODENf {
  padding-top: 40px !important;
}

.ButtonGroup-module__p-t-50___by8du {
  padding-top: 50px !important;
}

.ButtonGroup-module__p-l-20___PxRxc {
  padding-left: 20px !important;
}

.ButtonGroup-module__p-l-30___CNA1x {
  padding-left: 30px !important;
}

.ButtonGroup-module__p-l-40___k1yqt {
  padding-left: 40px !important;
}

.ButtonGroup-module__p-r-16___kZez_ {
  padding-right: 16px !important;
}

.ButtonGroup-module__p-r-20___YEPlA {
  padding-right: 20px !important;
}

.ButtonGroup-module__p-r-30____nfHf {
  padding-right: 30px !important;
}

.ButtonGroup-module__p-r-50___jgNJi {
  padding-right: 50px !important;
}

.ButtonGroup-module__p-r-60___R5zi7 {
  padding-right: 60px !important;
}

.ButtonGroup-module__m-b-1___OvTTd {
  margin-bottom: 1px !important;
}

.ButtonGroup-module__m-b-2___uZkdz {
  margin-bottom: 2px !important;
}

.ButtonGroup-module__m-b-6___wMMYQ {
  margin-bottom: 6px !important;
}

.ButtonGroup-module__m-b-8___BnAAv {
  margin-bottom: 8px !important;
}

.ButtonGroup-module__m-b-10____tDBj {
  margin-bottom: 10px !important;
}

.ButtonGroup-module__m-b-14___gkisg {
  margin-bottom: 14px !important;
}

.ButtonGroup-module__m-b-16___yCNHj {
  margin-bottom: 16px !important;
}

.ButtonGroup-module__m-b-20___lw988 {
  margin-bottom: 20px !important;
}

.ButtonGroup-module__m-b-22___YgCt2 {
  margin-bottom: 22px !important;
}

.ButtonGroup-module__m-b-24___vd01y {
  margin-bottom: 24px !important;
}

.ButtonGroup-module__m-b-30___JG_fC {
  margin-bottom: 30px !important;
}

.ButtonGroup-module__m-b-32___zkk82 {
  margin-bottom: 32px !important;
}

.ButtonGroup-module__m-b-40___Ilx4G {
  margin-bottom: 40px !important;
}

.ButtonGroup-module__m-t-2___waqCH {
  margin-top: 2px !important;
}

.ButtonGroup-module__m-t-3___QLMq7 {
  margin-top: 3px !important;
}

.ButtonGroup-module__m-t-4___jIPZl {
  margin-top: 4px !important;
}

.ButtonGroup-module__m-t-5___JCFXW {
  margin-top: 5px !important;
}

.ButtonGroup-module__m-t-8___qrE1r {
  margin-top: 8px !important;
}

.ButtonGroup-module__m-t-10___LrsJ2 {
  margin-top: 10px !important;
}

.ButtonGroup-module__m-t-15___Sp1dU {
  margin-top: 15px !important;
}

.ButtonGroup-module__m-t-16___OiyWG {
  margin-top: 16px !important;
}

.ButtonGroup-module__m-t-20___Vhyzx {
  margin-top: 20px !important;
}

.ButtonGroup-module__m-t-22___cB6HX {
  margin-top: 22px !important;
}

.ButtonGroup-module__m-t-30___LefVr {
  margin-top: 30px !important;
}

.ButtonGroup-module__m-t-32___bzznX {
  margin-top: 32px !important;
}

.ButtonGroup-module__m-l-auto___W9dhd {
  margin-left: auto !important;
}

.ButtonGroup-module__m-l-4___brzHo {
  margin-left: 4px !important;
}

.ButtonGroup-module__m-l-5___pXAVC {
  margin-left: 5px !important;
}

.ButtonGroup-module__m-l-6___V6Zg5 {
  margin-left: 6px !important;
}

.ButtonGroup-module__m-l-8___onPAy {
  margin-left: 8px !important;
}

.ButtonGroup-module__m-l-10___zHA1y {
  margin-left: 10px !important;
}

.ButtonGroup-module__m-l-16___wNxJy {
  margin-left: 16px !important;
}

.ButtonGroup-module__m-l-20___skds5 {
  margin-left: 20px !important;
}

.ButtonGroup-module__m-l-24___yCUnQ {
  margin-left: 24px !important;
}

.ButtonGroup-module__m-l-30___E4S6J {
  margin-left: 30px !important;
}

.ButtonGroup-module__m-l-35___iCYXs {
  margin-left: 35px !important;
}

.ButtonGroup-module__m-l-40___kYbSn {
  margin-left: 40px !important;
}

.ButtonGroup-module__m-r-8___LHt8Q {
  margin-right: 8px !important;
}

.ButtonGroup-module__m-r-10___kPqh_ {
  margin-right: 10px !important;
}

.ButtonGroup-module__m-r-16___XFfrR {
  margin-right: 16px !important;
}

.ButtonGroup-module__m-r-20___vOqzK {
  margin-right: 20px !important;
}

.ButtonGroup-module__m-r-24___kSZiH {
  margin-right: 24px !important;
}

.ButtonGroup-module__m-r-30___unXqC {
  margin-right: 30px !important;
}

.ButtonGroup-module__m-r-40___EKoLD {
  margin-right: 40px !important;
}

.ButtonGroup-module__border-r-3___FQfkV {
  border-radius: 3px !important;
}

.ButtonGroup-module__border-r-4___HhATg {
  border-radius: 4px !important;
}

.ButtonGroup-module__border-r-6___YFcCb {
  border-radius: 6px !important;
}

.ButtonGroup-module__border-r-10___QYfFI {
  border-radius: 10px !important;
}

.ButtonGroup-module__border-r-12___wSKAH {
  border-radius: 12px !important;
}

.ButtonGroup-module__border-r-16___kfE30 {
  border-radius: 16px !important;
}

.ButtonGroup-module__border-r-50___QgQHj {
  border-radius: 50% !important;
}

.ButtonGroup-module__primary-border___p95gO {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ButtonGroup-module__primary-border-b___zBZBW {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ButtonGroup-module__primary-border-t___YmlO3 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ButtonGroup-module__primary-border-l___qx6Vr {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ButtonGroup-module__primary-border-r___ln7ar {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ButtonGroup-module__secondary-border___dk1WM {
  border: 1px solid #637768;
}

.ButtonGroup-module__secondary-border-b___d9zaQ {
  border-bottom: 1px solid #637768;
}

.ButtonGroup-module__secondary-border-t___a4rnT {
  border-top: 1px solid #637768;
}

.ButtonGroup-module__secondary-border-l___jOr7L {
  border-left: 1px solid #637768;
}

.ButtonGroup-module__secondary-border-r___kvfuO {
  border-right: 1px solid #637768;
}

.ButtonGroup-module__gap-0___gNOm4 {
  gap: 0 !important;
}

.ButtonGroup-module__gap-2___zNgjr {
  gap: 2px !important;
}

.ButtonGroup-module__gap-4___LrorP {
  gap: 4px !important;
}

.ButtonGroup-module__gap-5___ta6dL {
  gap: 5px !important;
}

.ButtonGroup-module__gap-6___chiyA {
  gap: 6px !important;
}

.ButtonGroup-module__gap-8___RbH2y {
  gap: 8px !important;
}

.ButtonGroup-module__gap-10___Zap0F {
  gap: 10px !important;
}

.ButtonGroup-module__gap-12___KSOTK {
  gap: 12px !important;
}

.ButtonGroup-module__gap-14___PXpVb {
  gap: 14px !important;
}

.ButtonGroup-module__gap-16___NBIgE {
  gap: 16px !important;
}

.ButtonGroup-module__gap-18___sb422 {
  gap: 18px !important;
}

.ButtonGroup-module__gap-20___cTRR5 {
  gap: 20px !important;
}

.ButtonGroup-module__gap-24___EL8DZ {
  gap: 24px !important;
}

.ButtonGroup-module__gap-26___MHwbs {
  gap: 26px !important;
}

.ButtonGroup-module__gap-30___ZP6OL {
  gap: 30px !important;
}

.ButtonGroup-module__gap-32___vAAtp {
  gap: 32px !important;
}

.ButtonGroup-module__gap-40___fu_2I {
  gap: 40px !important;
}

.ButtonGroup-module__gap-50___sAFpL {
  gap: 50px !important;
}

.ButtonGroup-module__flex-1___O9hlU {
  flex: 1;
}

.ButtonGroup-module__flex-none___O6ghj {
  flex: none !important;
}

.ButtonGroup-module__flex-column___HoThK {
  display: flex;
  flex-direction: column !important;
}

.ButtonGroup-module__flex-row___WYdTa {
  display: flex;
  flex-direction: row !important;
}

.ButtonGroup-module__vertically-centered___kN6v8 {
  display: flex;
  align-items: center !important;
}

.ButtonGroup-module__horizontally-centered___uXpoG {
  display: flex;
  justify-content: center !important;
}

.ButtonGroup-module__horizontally-end___R2GlP {
  display: flex;
  justify-content: end !important;
}

.ButtonGroup-module__vertically-start___DlBkN {
  display: flex;
  align-items: start !important;
}

.ButtonGroup-module__space-between___LKUNI {
  display: flex;
  justify-content: space-between !important;
}

.ButtonGroup-module__flex-wrap___ZLAiG {
  flex-wrap: wrap !important;
}

.ButtonGroup-module__height-100___azhMd {
  height: 100%;
}

.ButtonGroup-module__width-50___zUwM0 {
  width: 50% !important;
}

.ButtonGroup-module__width-100___cENS6 {
  width: 100%;
}

.ButtonGroup-module__cursor-pointer___EBge8 {
  cursor: pointer;
}

.ButtonGroup-module__cursor-not-allowed___CKFMm {
  cursor: not-allowed !important;
}

.ButtonGroup-module__absolute-centered___EtGC4 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ButtonGroup-module__absolute___PnOFU {
  position: absolute;
}

.ButtonGroup-module__relative___DVKDg {
  position: relative;
}

.ButtonGroup-module__fixed___oOmD0 {
  position: fixed;
}

.ButtonGroup-module__visible___GsTrw {
  opacity: 1;
}

.ButtonGroup-module__invisible___Jdgzk {
  opacity: 0;
}

.ButtonGroup-module__col-90___Cs7t7 {
  width: 90% !important;
}

.ButtonGroup-module__col-auto___Gaqs1 {
  width: auto !important;
}

.ButtonGroup-module__medical-tabs___An14C {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ButtonGroup-module__medical-table-new___HYZgz {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ButtonGroup-module__medical-table-new___HYZgz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ButtonGroup-module__medical-table-new___HYZgz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ButtonGroup-module__medical-table-new___HYZgz::-webkit-scrollbar-track {
  display: none;
}
.ButtonGroup-module__medical-table-new___HYZgz.ButtonGroup-module__no-pagination___Sn71X {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ButtonGroup-module__medical-table-new___HYZgz.ButtonGroup-module__no-pagination___Sn71X:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ButtonGroup-module__medical-table-new___HYZgz.ButtonGroup-module__no-pagination___Sn71X::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ButtonGroup-module__medical-table-new___HYZgz.ButtonGroup-module__no-pagination___Sn71X::-webkit-scrollbar-track {
  display: none;
}

.ButtonGroup-module__medical-table-empty___OhZ00 {
  padding: 14px 40px !important;
}

.ButtonGroup-module__icon-btn___efk0j {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ButtonGroup-module__search-icon___fi6J7 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ButtonGroup-module__disable-select___EgDKA {
  user-select: none;
}

.ButtonGroup-module__break-word___pSTwA {
  word-break: break-word;
}

.ButtonGroup-module__popup-clear-btn___DVOf2 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ButtonGroup-module__scroll-m-b-20___ubTrv {
  scroll-margin-bottom: 20px;
}

.ButtonGroup-module__group___ToqLx {
  display: inline-flex;
  flex-wrap: wrap;
}

.ButtonGroup-module__fullWidth___FIu7K {
  display: flex;
}
.ButtonGroup-module__fullWidth___FIu7K .ButtonGroup-module__button___fye3V {
  flex: 1;
  justify-content: center;
}

.ButtonGroup-module__button___fye3V {
  padding: 4px 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #3f3f46;
  background: #ffffff;
  border: 1px solid #d4d4d8;
  border-radius: 0;
  cursor: pointer;
}
.ButtonGroup-module__button___fye3V:hover:not(:disabled) {
  border-color: #a1a1aa;
}
.ButtonGroup-module__button___fye3V:disabled {
  opacity: 0.5;
  cursor: default;
}
.ButtonGroup-module__button___fye3V:first-child {
  border-radius: 6px 0 0 6px;
}
.ButtonGroup-module__button___fye3V:last-child {
  border-radius: 0 6px 6px 0;
}
.ButtonGroup-module__button___fye3V:only-child {
  border-radius: 6px;
}
.ButtonGroup-module__button___fye3V + .ButtonGroup-module__button___fye3V {
  margin-left: -1px;
}

.ButtonGroup-module__primary___S6mNW {
  color: #fafafa;
  background: #18181b;
  border-color: #18181b;
}
.ButtonGroup-module__primary___S6mNW:hover:not(:disabled) {
  background: #27272a;
  border-color: #27272a;
}

.ButtonGroup-module__activeNeutral___IM8PL {
  color: #fafafa;
  background: #18181b;
  border-color: #18181b;
}

.ButtonGroup-module__activeDanger____ldwh {
  color: #991b1b;
  background: #fef2f2;
  border-color: #fecaca;
}

.ButtonGroup-module__activeWarning___t9OsN {
  color: #854d0e;
  background: #fefce8;
  border-color: #fde68a;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/ButtonGroup/ButtonGroup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,oBAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,aAAA;AA8pBF;AA5pBE;EACE,OAAA;EACA,uBAAA;AA8pBJ;;AA1pBA;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AA6pBF;AA3pBE;EACE,qBAAA;AA6pBJ;AA1pBE;EACE,YAAA;EACA,eAAA;AA4pBJ;AAzpBE;EACE,0BAAA;AA2pBJ;AAxpBE;EACE,0BAAA;AA0pBJ;AAvpBE;EACE,kBAAA;AAypBJ;AAtpBE;EACE,iBAAA;AAwpBJ;;AAppBA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AAupBF;AArpBE;EACE,mBAAA;EACA,qBAAA;AAupBJ;;AAnpBA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AAspBF;;AAnpBA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AAspBF;;AAnpBA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AAspBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.group {\n  display: inline-flex;\n  flex-wrap: wrap;\n}\n\n.fullWidth {\n  display: flex;\n\n  .button {\n    flex: 1;\n    justify-content: center;\n  }\n}\n\n.button {\n  padding: 4px 10px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: tone-color(neutral, text);\n  background: #ffffff;\n  border: 1px solid #d4d4d8;\n  border-radius: 0;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: #a1a1aa;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n\n  &:first-child {\n    border-radius: 6px 0 0 6px;\n  }\n\n  &:last-child {\n    border-radius: 0 6px 6px 0;\n  }\n\n  &:only-child {\n    border-radius: 6px;\n  }\n\n  & + & {\n    margin-left: -1px;\n  }\n}\n\n.primary {\n  color: #fafafa;\n  background: #18181b;\n  border-color: #18181b;\n\n  &:hover:not(:disabled) {\n    background: #27272a;\n    border-color: #27272a;\n  }\n}\n\n.activeNeutral {\n  color: #fafafa;\n  background: #18181b;\n  border-color: #18181b;\n}\n\n.activeDanger {\n  color: tone-color(danger, text);\n  background: tone-color(danger, bg);\n  border-color: tone-color(danger, border);\n}\n\n.activeWarning {\n  color: tone-color(warning, text);\n  background: tone-color(warning, bg);\n  border-color: tone-color(warning, border);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ButtonGroup-module__font-s-10___W82S5`,
	"fontS12": `ButtonGroup-module__font-s-12___iC0xm`,
	"fontS13": `ButtonGroup-module__font-s-13___nod1S`,
	"fontS14": `ButtonGroup-module__font-s-14___ii1W8`,
	"fontS15": `ButtonGroup-module__font-s-15___yseB5`,
	"fontS16": `ButtonGroup-module__font-s-16___MKRwX`,
	"fontS18": `ButtonGroup-module__font-s-18___AYk95`,
	"fontS20": `ButtonGroup-module__font-s-20___m1jI6`,
	"fontS22": `ButtonGroup-module__font-s-22___UzsFN`,
	"fontS28": `ButtonGroup-module__font-s-28___kwNpd`,
	"fontW400": `ButtonGroup-module__font-w-400___JGhz_`,
	"fontW500": `ButtonGroup-module__font-w-500___gAfyQ`,
	"fontW600": `ButtonGroup-module__font-w-600___z6Cit`,
	"fontW700": `ButtonGroup-module__font-w-700___UHNnz`,
	"p5": `ButtonGroup-module__p-5___DXbGS`,
	"p12": `ButtonGroup-module__p-12____ZrJR`,
	"p16": `ButtonGroup-module__p-16___MtpqW`,
	"p30": `ButtonGroup-module__p-30___B18EE`,
	"pB0": `ButtonGroup-module__p-b-0___WdZ_n`,
	"pB5": `ButtonGroup-module__p-b-5___EFsTx`,
	"pB10": `ButtonGroup-module__p-b-10___Cz0Rt`,
	"pB12": `ButtonGroup-module__p-b-12___RlgXw`,
	"pB16": `ButtonGroup-module__p-b-16___S3Yqy`,
	"pB18": `ButtonGroup-module__p-b-18___H2qE_`,
	"pB20": `ButtonGroup-module__p-b-20___KgRrD`,
	"pB25": `ButtonGroup-module__p-b-25___PI0Zv`,
	"pB30": `ButtonGroup-module__p-b-30___ib6EV`,
	"pB50": `ButtonGroup-module__p-b-50___yE2YN`,
	"pT0": `ButtonGroup-module__p-t-0___XBthT`,
	"pT12": `ButtonGroup-module__p-t-12___wrPfy`,
	"pT16": `ButtonGroup-module__p-t-16___EMQmg`,
	"pT18": `ButtonGroup-module__p-t-18___eufcU`,
	"pT20": `ButtonGroup-module__p-t-20___TUKcU`,
	"pT30": `ButtonGroup-module__p-t-30___p55QW`,
	"pT40": `ButtonGroup-module__p-t-40___ODENf`,
	"pT50": `ButtonGroup-module__p-t-50___by8du`,
	"pL20": `ButtonGroup-module__p-l-20___PxRxc`,
	"pL30": `ButtonGroup-module__p-l-30___CNA1x`,
	"pL40": `ButtonGroup-module__p-l-40___k1yqt`,
	"pR16": `ButtonGroup-module__p-r-16___kZez_`,
	"pR20": `ButtonGroup-module__p-r-20___YEPlA`,
	"pR30": `ButtonGroup-module__p-r-30____nfHf`,
	"pR50": `ButtonGroup-module__p-r-50___jgNJi`,
	"pR60": `ButtonGroup-module__p-r-60___R5zi7`,
	"mB1": `ButtonGroup-module__m-b-1___OvTTd`,
	"mB2": `ButtonGroup-module__m-b-2___uZkdz`,
	"mB6": `ButtonGroup-module__m-b-6___wMMYQ`,
	"mB8": `ButtonGroup-module__m-b-8___BnAAv`,
	"mB10": `ButtonGroup-module__m-b-10____tDBj`,
	"mB14": `ButtonGroup-module__m-b-14___gkisg`,
	"mB16": `ButtonGroup-module__m-b-16___yCNHj`,
	"mB20": `ButtonGroup-module__m-b-20___lw988`,
	"mB22": `ButtonGroup-module__m-b-22___YgCt2`,
	"mB24": `ButtonGroup-module__m-b-24___vd01y`,
	"mB30": `ButtonGroup-module__m-b-30___JG_fC`,
	"mB32": `ButtonGroup-module__m-b-32___zkk82`,
	"mB40": `ButtonGroup-module__m-b-40___Ilx4G`,
	"mT2": `ButtonGroup-module__m-t-2___waqCH`,
	"mT3": `ButtonGroup-module__m-t-3___QLMq7`,
	"mT4": `ButtonGroup-module__m-t-4___jIPZl`,
	"mT5": `ButtonGroup-module__m-t-5___JCFXW`,
	"mT8": `ButtonGroup-module__m-t-8___qrE1r`,
	"mT10": `ButtonGroup-module__m-t-10___LrsJ2`,
	"mT15": `ButtonGroup-module__m-t-15___Sp1dU`,
	"mT16": `ButtonGroup-module__m-t-16___OiyWG`,
	"mT20": `ButtonGroup-module__m-t-20___Vhyzx`,
	"mT22": `ButtonGroup-module__m-t-22___cB6HX`,
	"mT30": `ButtonGroup-module__m-t-30___LefVr`,
	"mT32": `ButtonGroup-module__m-t-32___bzznX`,
	"mLAuto": `ButtonGroup-module__m-l-auto___W9dhd`,
	"mL4": `ButtonGroup-module__m-l-4___brzHo`,
	"mL5": `ButtonGroup-module__m-l-5___pXAVC`,
	"mL6": `ButtonGroup-module__m-l-6___V6Zg5`,
	"mL8": `ButtonGroup-module__m-l-8___onPAy`,
	"mL10": `ButtonGroup-module__m-l-10___zHA1y`,
	"mL16": `ButtonGroup-module__m-l-16___wNxJy`,
	"mL20": `ButtonGroup-module__m-l-20___skds5`,
	"mL24": `ButtonGroup-module__m-l-24___yCUnQ`,
	"mL30": `ButtonGroup-module__m-l-30___E4S6J`,
	"mL35": `ButtonGroup-module__m-l-35___iCYXs`,
	"mL40": `ButtonGroup-module__m-l-40___kYbSn`,
	"mR8": `ButtonGroup-module__m-r-8___LHt8Q`,
	"mR10": `ButtonGroup-module__m-r-10___kPqh_`,
	"mR16": `ButtonGroup-module__m-r-16___XFfrR`,
	"mR20": `ButtonGroup-module__m-r-20___vOqzK`,
	"mR24": `ButtonGroup-module__m-r-24___kSZiH`,
	"mR30": `ButtonGroup-module__m-r-30___unXqC`,
	"mR40": `ButtonGroup-module__m-r-40___EKoLD`,
	"borderR3": `ButtonGroup-module__border-r-3___FQfkV`,
	"borderR4": `ButtonGroup-module__border-r-4___HhATg`,
	"borderR6": `ButtonGroup-module__border-r-6___YFcCb`,
	"borderR10": `ButtonGroup-module__border-r-10___QYfFI`,
	"borderR12": `ButtonGroup-module__border-r-12___wSKAH`,
	"borderR16": `ButtonGroup-module__border-r-16___kfE30`,
	"borderR50": `ButtonGroup-module__border-r-50___QgQHj`,
	"primaryBorder": `ButtonGroup-module__primary-border___p95gO`,
	"primaryBorderB": `ButtonGroup-module__primary-border-b___zBZBW`,
	"primaryBorderT": `ButtonGroup-module__primary-border-t___YmlO3`,
	"primaryBorderL": `ButtonGroup-module__primary-border-l___qx6Vr`,
	"primaryBorderR": `ButtonGroup-module__primary-border-r___ln7ar`,
	"secondaryBorder": `ButtonGroup-module__secondary-border___dk1WM`,
	"secondaryBorderB": `ButtonGroup-module__secondary-border-b___d9zaQ`,
	"secondaryBorderT": `ButtonGroup-module__secondary-border-t___a4rnT`,
	"secondaryBorderL": `ButtonGroup-module__secondary-border-l___jOr7L`,
	"secondaryBorderR": `ButtonGroup-module__secondary-border-r___kvfuO`,
	"gap0": `ButtonGroup-module__gap-0___gNOm4`,
	"gap2": `ButtonGroup-module__gap-2___zNgjr`,
	"gap4": `ButtonGroup-module__gap-4___LrorP`,
	"gap5": `ButtonGroup-module__gap-5___ta6dL`,
	"gap6": `ButtonGroup-module__gap-6___chiyA`,
	"gap8": `ButtonGroup-module__gap-8___RbH2y`,
	"gap10": `ButtonGroup-module__gap-10___Zap0F`,
	"gap12": `ButtonGroup-module__gap-12___KSOTK`,
	"gap14": `ButtonGroup-module__gap-14___PXpVb`,
	"gap16": `ButtonGroup-module__gap-16___NBIgE`,
	"gap18": `ButtonGroup-module__gap-18___sb422`,
	"gap20": `ButtonGroup-module__gap-20___cTRR5`,
	"gap24": `ButtonGroup-module__gap-24___EL8DZ`,
	"gap26": `ButtonGroup-module__gap-26___MHwbs`,
	"gap30": `ButtonGroup-module__gap-30___ZP6OL`,
	"gap32": `ButtonGroup-module__gap-32___vAAtp`,
	"gap40": `ButtonGroup-module__gap-40___fu_2I`,
	"gap50": `ButtonGroup-module__gap-50___sAFpL`,
	"flex1": `ButtonGroup-module__flex-1___O9hlU`,
	"flexNone": `ButtonGroup-module__flex-none___O6ghj`,
	"flexColumn": `ButtonGroup-module__flex-column___HoThK`,
	"flexRow": `ButtonGroup-module__flex-row___WYdTa`,
	"verticallyCentered": `ButtonGroup-module__vertically-centered___kN6v8`,
	"horizontallyCentered": `ButtonGroup-module__horizontally-centered___uXpoG`,
	"horizontallyEnd": `ButtonGroup-module__horizontally-end___R2GlP`,
	"verticallyStart": `ButtonGroup-module__vertically-start___DlBkN`,
	"spaceBetween": `ButtonGroup-module__space-between___LKUNI`,
	"flexWrap": `ButtonGroup-module__flex-wrap___ZLAiG`,
	"height100": `ButtonGroup-module__height-100___azhMd`,
	"width50": `ButtonGroup-module__width-50___zUwM0`,
	"width100": `ButtonGroup-module__width-100___cENS6`,
	"cursorPointer": `ButtonGroup-module__cursor-pointer___EBge8`,
	"cursorNotAllowed": `ButtonGroup-module__cursor-not-allowed___CKFMm`,
	"absoluteCentered": `ButtonGroup-module__absolute-centered___EtGC4`,
	"absolute": `ButtonGroup-module__absolute___PnOFU`,
	"relative": `ButtonGroup-module__relative___DVKDg`,
	"fixed": `ButtonGroup-module__fixed___oOmD0`,
	"visible": `ButtonGroup-module__visible___GsTrw`,
	"invisible": `ButtonGroup-module__invisible___Jdgzk`,
	"col90": `ButtonGroup-module__col-90___Cs7t7`,
	"colAuto": `ButtonGroup-module__col-auto___Gaqs1`,
	"medicalTabs": `ButtonGroup-module__medical-tabs___An14C`,
	"medicalTableNew": `ButtonGroup-module__medical-table-new___HYZgz`,
	"noPagination": `ButtonGroup-module__no-pagination___Sn71X`,
	"medicalTableEmpty": `ButtonGroup-module__medical-table-empty___OhZ00`,
	"iconBtn": `ButtonGroup-module__icon-btn___efk0j`,
	"searchIcon": `ButtonGroup-module__search-icon___fi6J7`,
	"disableSelect": `ButtonGroup-module__disable-select___EgDKA`,
	"breakWord": `ButtonGroup-module__break-word___pSTwA`,
	"popupClearBtn": `ButtonGroup-module__popup-clear-btn___DVOf2`,
	"scrollMB20": `ButtonGroup-module__scroll-m-b-20___ubTrv`,
	"group": `ButtonGroup-module__group___ToqLx`,
	"fullWidth": `ButtonGroup-module__fullWidth___FIu7K`,
	"button": `ButtonGroup-module__button___fye3V`,
	"primary": `ButtonGroup-module__primary___S6mNW`,
	"activeNeutral": `ButtonGroup-module__activeNeutral___IM8PL`,
	"activeDanger": `ButtonGroup-module__activeDanger____ldwh`,
	"activeWarning": `ButtonGroup-module__activeWarning___t9OsN`
};
module.exports = ___CSS_LOADER_EXPORT___;
